'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _displayPrice = require('../../../../helpers/displayPrice');var _displayPrice2 = _interopRequireDefault(_displayPrice);
var _CellInfoIconsBlock = require('../components/CellInfoIconsBlock/CellInfoIconsBlock');var _CellInfoIconsBlock2 = _interopRequireDefault(_CellInfoIconsBlock);
var _CellPhotoBlock = require('../components/CellPhotoBlock/CellPhotoBlock');var _CellPhotoBlock2 = _interopRequireDefault(_CellPhotoBlock);
var _index = require('../../../index');

var _parkingConverter = require('../../../../utils/parkingConverter');var _parkingConverter2 = _interopRequireDefault(_parkingConverter);

var _OMBaseForeignCountryCell = require('./OMBaseForeignCountryCell.scss');var defaultStyles = _interopRequireWildcard(_OMBaseForeignCountryCell);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var OMBaseForeignCountryCell = function (_Component) {_inherits(OMBaseForeignCountryCell, _Component);function OMBaseForeignCountryCell(props) {_classCallCheck(this, OMBaseForeignCountryCell);var _this = _possibleConstructorReturn(this, _Component.call(this, props));_this.



































    renderLabelNew = function () {return _this.props.isNewProperty &&
      _react2.default.createElement('div', { className: _this.styles.labelNew },
        _react2.default.createElement(_index.OMLabelNew, {
          label: _this.props.newPropertyLabel.toString(),
          title: _this.props.newPropertyTitle.toString(),
          isMobile: _this.props.isMobile,
          className: 'foreignLabel' }));};_this.




    renderLabelTop = function () {return _this.props.isTopPromotedProperty &&
      _react2.default.createElement('div', { className: _this.styles.labelTop },
        _react2.default.createElement(_index.OMLabelTop, {
          label: 'TOP',
          isMobile: _this.props.isMobile,
          className: 'foreignLabel' }));};_this.styles = defaultStyles;_this.state = { showNote: false };return _this;}OMBaseForeignCountryCell.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {var propertyNote = _ref.propertyNote;if (!propertyNote && this.props.propertyNote !== propertyNote) {this.setState({ showNote: false });}};OMBaseForeignCountryCell.prototype.shouldComponentUpdate = function shouldComponentUpdate(newProps, newState) {var isIdChanged = newProps.id !== this.props.id;var isPhotoChanged = newProps.photo !== this.props.photo;var isLocaleChanged = newProps.locale !== this.props.locale;var isPriceChanged = newProps.price !== this.props.price;var isFavoriteStateChanged = newProps.isFavorite !== this.props.isFavorite;var isShowNoteChanged = newState.showNote !== this.state.showNote;var isPropertyNoteChanged = newProps.propertyNote !== this.props.propertyNote;return isIdChanged || isLocaleChanged || isFavoriteStateChanged || isShowNoteChanged || isPropertyNoteChanged || isPhotoChanged || isPriceChanged;};OMBaseForeignCountryCell.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {if (!prevState.showNote && this.state.showNote) {document.body.addEventListener('click', this.hideNote, true);}if (prevState.showNote && !this.state.showNote) {document.body.removeEventListener('click', this.hideNote, true);}};OMBaseForeignCountryCell.prototype.




  render = function render() {
    var parkingSpots = (0, _parkingConverter2.default)(this.props.parkingSpots);
    var groundFloor = +this.props.floor === 0;
    var renderPrice = function renderPrice(data) {return (0, _displayPrice2.default)(data, defaultStyles);};

    return (
      _react2.default.createElement('div', { className: this.styles.foreignCountryRow },
        _react2.default.createElement('div', { className: this.styles.photoBlockWrapper },
          _react2.default.createElement(_CellPhotoBlock2.default, {
            locale: this.props.locale,
            isFavorite: this.props.isFavorite,
            hasVRLink: this.props.hasVRLink,
            toggleFavorite: this.props.toggleFavorite,
            isRtl: this.props.isRtl,
            photo: this.props.photo,
            price: this.props.price,
            searchOption: this.props.searchOption,
            translate: this.props.translate,
            className: 'foreignPropertyCellPhotoBlock',
            images: this.props.images,
            withoutPrice: true })),



        _react2.default.createElement('div', { className: this.styles.propertyDescription },
          _react2.default.createElement('div', { className: this.styles.iconsWrapper },
            this.renderLabelNew(),
            this.renderLabelTop()),

          _react2.default.createElement('div', null,
            _react2.default.createElement('div', { className: 'priceForeignCountry' }, renderPrice(this.props)),
            _react2.default.createElement('div', { className: this.styles.propertyType },
              this.props.propertyType),

            _react2.default.createElement('div', { property: 'address', className: this.styles.propertyAddress },
              this.props.address && _react2.default.createElement('div', null, this.props.address),
              this.props.city && _react2.default.createElement('div', null, this.props.city),
              this.props.countryName && _react2.default.createElement('div', null, this.props.countryName))),


          _react2.default.createElement(_CellInfoIconsBlock2.default, {
            locale: this.props.locale,
            area: this.props.area,
            floor: groundFloor ? this.props.groundFloorTitle.toString() : this.props.floor,
            floorIconTitle: this.props.floorIconTitle,
            parkingIconTitle: this.props.parkingIconTitle,
            parkingSpots: parkingSpots,
            rooms: this.props.rooms,
            roomsIconTitle: this.props.roomsIconTitle,
            squareIconTitle: this.props.squareIconTitle,
            className: 'foreignCountryIcons' }))));




  };return OMBaseForeignCountryCell;}(_react.Component);


OMBaseForeignCountryCell.propTypes = {
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  propertyType: _propTypes2.default.string,
  photo: _propTypes2.default.string,
  images: _propTypes2.default.array,
  price: _propTypes2.default.number,
  address: _propTypes2.default.string,
  rooms: _propTypes2.default.number,
  parkingSpots: _propTypes2.default.object,
  city: _propTypes2.default.string,
  area: _propTypes2.default.number,
  floor: _propTypes2.default.number,
  isTopPromotedProperty: _propTypes2.default.bool,
  parkingIconTitle: _propTypes2.default.func,
  roomsIconTitle: _propTypes2.default.func,
  floorIconTitle: _propTypes2.default.func,
  squareIconTitle: _propTypes2.default.func,
  groundFloorTitle: _propTypes2.default.func,
  newPropertyTitle: _propTypes2.default.string,
  newPropertyLabel: _propTypes2.default.string,
  topPropertyLabel: _propTypes2.default.func,
  searchOption: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  isNewProperty: _propTypes2.default.bool,
  propertyNote: _propTypes2.default.string,
  isFavorite: _propTypes2.default.bool,
  hasVRLink: _propTypes2.default.bool,
  toggleFavorite: _propTypes2.default.func,
  countryName: _propTypes2.default.string };exports.default =


OMBaseForeignCountryCell;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/OMBaseForeignCountryCell/OMBaseForeignCountryCell.js
// module id = 2759
// module chunks = 0